export default "__VITE_PUBLIC_ASSET__43ade33d__"